import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {UtilsService} from './utils.service';
import {
  AuthSessionModel,
  SessionAuthenticatorDetails,
  SessionDeviceCtx,
  SessionUbaDetails
} from '../models/auth-session.model';
@Injectable({
  providedIn: 'root'
})
export class AuthSessionsService {

  endpoint = environment.API_URL + "rest/vsm";

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService) {
  }

  fetchAuthenticationSessions(from: Date, to: Date) {
    let params = new HttpParams().set("ts1", from.getTime().toString());
    params = params.append("ts2", to.getTime().toString());
    return this.http
      .get<any>(
        this.endpoint + "/sessions",
        {
          params: params
        }
      )
      .pipe(
        map(responseData => {
          const sessions = responseData.authenticationSessions.map((item) => {
            return this.toAuthSessionPreview(item);
          });
          return {authSessions: sessions, showMap: responseData.showMapSsp};
        })
      )
  }

  getSessionDetails(sessionId: string) {
    return this.http
      .get<any>(`${this.endpoint}/sessions/details/${sessionId}`)
      .pipe(
        map(responseData => {
          return this.toAuthSession(responseData.sessionView);
        })
      )
  }

  fetchActivity() {
    let params = new HttpParams().set("ts1", new Date().getTime().toString());
    params = params.append("ts2", new Date().getTime().toString());
    return this.http
      .get<any>(
        this.endpoint + "/activity",
        {
          params: params
        }
      )
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  fetchAuthenticationSession(id: string) {
    return this.http
      .get<any>(
        this.endpoint + "/details/" + id
      )
      .pipe(
        map(response => {
          let item = response.sessionEntry;
          return this.toAuthSession(item);
        })
      )
  }

  toAuthSessionPreview(item) {
    const authenticatorsDetails = item.biometricMethods
      ? this.getAuthenticatorsDetails(item.biometricMethods)
      : null;

    return {
      id: item?.id,
      requestTime: item?.requestTime,
      application: item?.exploiterDeviceContext?.serviceIdentifier,
      location: this.getLocation(item?.location),
      authenticationDeviceName: item?.authenticationDevicePhone,
      authenticationMode: item?.authenticationMode,
      authenticatorsDetails: authenticatorsDetails,
      status: item?.status
    }
  }

  public toAuthSession(item) {
    const authenticatorsDetails = item.biometricMethods
      ? this.getAuthenticatorsDetails(item.biometricMethods)
      : null;
    return new AuthSessionModel(
      item.id,
      item.identityDisplayName,
      item.identityUpn,
      item.status,
      item.userIdentityAssertionMethods,
      authenticatorsDetails,
      item.authenticationResult,
      this.getUbaDetails(item.ubaMotionOutput),
      this.getUbaDetails(item.ubaContextOutput),
      item.exploiterDeviceContext.serviceIdentifier,
      item.exploiterDeviceContext.serviceFriendlyName,
      item.authenticationDevicePhone,
      item.exploiterDeviceName,
      item.httpContextIp,
      this.getLocation(item.location),
      item?.location.source,
      item.requestTime ? new Date(item.requestTime) : null,
      item.authenticationTime ? new Date(item.authenticationTime) : null,
      this.getDeviceContext(item.exploiterDeviceContext),
      this.getDeviceContext(item.authenticatorDeviceContext),
      item.transactionCode,
      item.journeyId,
      item.journeyDefinitionId,
      item.identityId,
      item.authenticationMode,
      JSON.stringify(item)
    );
  }

  getAuthenticatorsDetails(biometricMethods: any) {
    let result: Array<SessionAuthenticatorDetails> = new Array();
    if (biometricMethods) {
      Object.keys(biometricMethods).forEach((key, index) => {
        let value = biometricMethods[key];
        result.push(new SessionAuthenticatorDetails(value.type, value.status, value.retries));
      });
    }
    return result;
  }

  getDeviceContext(deviceCtx: any) {
    let result: SessionDeviceCtx = new SessionDeviceCtx(
      deviceCtx.deviceMake, deviceCtx.deviceModel, deviceCtx.osName, deviceCtx.osVersion,
      deviceCtx.internetConnectionType, deviceCtx.userAgentName, deviceCtx.userAgentVersion, deviceCtx?.ip);
    return result;
  }

  getUbaDetails(ubaDetails: any) {
    const result: SessionUbaDetails = new SessionUbaDetails(
      ubaDetails?.score,
      ubaDetails?.answer,
      ubaDetails?.answerConfidence,
      ubaDetails?.scoreReason,
      ubaDetails?.criteriaMet,
      ubaDetails?.errorMessage
    );
    return result;
  }

  getLocation(locationObj) {
    let location = {
      locationMap: this.utilsService.buildLocationString(locationObj),
      coordinates: locationObj.coordinates,
      errorCode: locationObj.errorCode
    }
    return location;
  }
}
